import PropTypes from 'prop-types';
import React, {Component} from 'react';

//components
import Spinner from 'components/Spinner';

//styles
import {StyledAnchor, StyledButton, StyledButtonCaption, StyledButtonGroup, StyledLink} from './styles';

export class Button extends Component {
  static defaultProps = {
    block: false,
    design: 'solid',
    disabled: false,
    loading: false,
    type: 'button'
  };

  static propTypes = {
    block: PropTypes.bool,
    design: PropTypes.oneOf([
      'outline',
      'solid',
      'solid-black',
      'solid-white',
      'solid-cool',
      'text',
      'text-alternative-hover',
      'text-black',
      'white-green'
    ]),
    disabled: PropTypes.bool,
    loading: PropTypes.bool,
    type: PropTypes.oneOf(['button', 'reset', 'submit']),
    style: React.CSSProperties
  };

  getRootComponent = () => {
    const {href, route} = this.props;

    if (route) {
      return StyledLink;
    }

    if (href) {
      return StyledAnchor;
    }

    return StyledButton;
  };

  render() {
    const {disabled, loading, type, style, ...forwardedProps} = this.props;

    const RootComponent = this.getRootComponent();

    return (
      <RootComponent
        disabled={disabled || loading}
        type={RootComponent === StyledButton ? type : null}
        style={style}
        {...forwardedProps}
      >
        {loading && <Spinner color="currentColor" size="1em" centerAbs centerX centerY />}
        <StyledButtonCaption isInvisible={loading}>{this.props.children}</StyledButtonCaption>
      </RootComponent>
    );
  }
}

export const ButtonGroup = StyledButtonGroup;
